export type CVBuilderFormValues = {
  language: string;
  personalDetails: PersonalDetails;
  education: EducationEntry[];
  professionalExperience: ExperienceEntry[];
  hardSkills: HardSkillEntry[];
  softSkills: string[];
  languageSkills: LanguageSkillEntry[];
  certificates: string[];
  completedSteps?: string[]; // Track which steps have been completed/passed
};

export type EducationEntry = {
  university?: string;
  study?: string;
  degree?: string;
  currentlyEnrolled?: boolean;
  studyStart?: string;
  studyEnd?: string;
};

export type ExperienceEntry = {
  companyName?: string;
  startDate?: string;
  endDate?: string;
  currentlyWorking?: boolean;
  position?: string;
  description?: string;
};

export type PersonalDetails = {
  firstname?: string;
  lastname?: string;
  email?: string;
  phone?: string;
  zip?: string;
  insuranceType?: string;
  insuranceName?: string;
  weeklyAvailableHours?: number | string;
  stipendBafoeg?: string;
};

export type HardSkillEntry = {
  name?: string;
  level?: string;
  professionallyUsed?: boolean;
};

export type LanguageSkillEntry = {
  language?: string;
  level?: string;
};

export type CVBuilderDBValues = {
  language: string;
  personalDetails: Omit<
    PersonalDetails,
    'weeklyAvailableHours' | 'stipendBafoeg'
  > & {
    weeklyAvailableHours?: number;
    stipendBafoeg?: boolean;
  };
  education: EducationEntry[];
  professionalExperience: ExperienceEntry[];
  hardSkills: HardSkillEntry[];
  softSkills: string[];
  languageSkills: LanguageSkillEntry[];
  certificates: string[];
  completedSteps?: string[];
};

export enum CVBuilderFormKeys {
  LANGUAGE = 'language',
  PERSONAL_DETAILS = 'personalDetails',
  EDUCATION = 'education',
  PROFESSIONAL_EXPERIENCE = 'professionalExperience',
  FIRST_NAME = 'firstname',
  LAST_NAME = 'lastname',
  EMAIL = 'email',
  PHONE = 'phone',
  ZIP = 'zip',
  INSURANCE_TYPE = 'insuranceType',
  INSURANCE_NAME = 'insuranceName',
  WEEKLY_AVAILABLE_HOURS = 'weeklyAvailableHours',
  STIPEND_BAFOEG = 'stipendBafoeg',
  HARD_SKILLS = 'hardSkills',
  SOFT_SKILLS = 'softSkills',
  LANGUAGE_SKILLS = 'languageSkills'
}
